export default __webpack_public_path__ + "static/media/chevron_down.99aceb53.svg";